import classNames from 'classnames';
import styles from './styles.module.css';
import PolicyRequired from '../../../../../components/common/PolicyRequired';
import { etcColumnRequiredPolicies } from '../';

const TableHead = () => (
  <thead>
    <tr className={styles.head}>
      <th className={classNames(styles.headCell, styles.companyName)}>
        会社名
      </th>
      <th className={classNames(styles.headCell, styles.address)}>住所</th>
      <th className={classNames(styles.headCell, styles.companyType)}>
        会社区分
      </th>
      <th className={classNames(styles.headCell, styles.wasteItems)}>
        処理区分
      </th>
      <PolicyRequired anyPolicy={etcColumnRequiredPolicies}>
        <th className={classNames(styles.headCell, styles.etc)}></th>
      </PolicyRequired>
    </tr>
  </thead>
);

export default TableHead;
